import { has } from 'lodash';

function sanitizePropertyData(newFormData) {
  const { data } = newFormData.property;

  const fireKeys = [
    'whatHappened',
    'fireStartLocation',
    'neighboursFireDamage',
    'howFireStart',
    'fireDamage', // This is strange key mapping, please verify
    'damagedItemsFire',
    'reportedFire',
    'file_fireReport',
  ];

  const waterKeys = [
    'whatDoesTheWaterLookLike',
    'whereWaterFrom',
    'damagedItemsWater',
  ];

  const windKeys = [
    'windHailDamage',
    'fallenTreesOnProperty',
    'treesDamageProperty',
    'damagedItemsWindHail',
  ];

  const theftOrLostKeys = [
    'itemLostOrStolen',
    'lastTimeSawItem',
    'typeMissingItems',
    'forcedEntryDamage',
  ];

  const keysShouldNotHaveSet = new Set();

  switch (data?.lossCause.value) {
    case 'fire':
      waterKeys.forEach((key) => keysShouldNotHaveSet.add(key));
      windKeys.forEach((key) => keysShouldNotHaveSet.add(key));
      theftOrLostKeys.forEach((key) => keysShouldNotHaveSet.add(key));
      Array.from(keysShouldNotHaveSet).forEach(
        (key) => delete data[key],
      );
      if (data?.fireStartLocation && data?.fireStartLocation.value === 'neighbour') {
        delete data?.neighboursFireDamage;
        delete data?.howFireStart;
      }

      if (data?.fireStartLocation && (data?.fireStartLocation.value !== 'homeExterior' && data?.fireStartLocation.value !== 'shedStructure')) {
        delete data?.damageFromStormOrWeather;
      }
      delete data?.description;
      delete data?.belongings?.damagedItemsWindHail;
      delete data?.belongings?.damagedItemsWater;
      break;

    case 'water':
      fireKeys.forEach((key) => keysShouldNotHaveSet.add(key));
      windKeys.forEach((key) => keysShouldNotHaveSet.add(key));
      theftOrLostKeys.forEach((key) => keysShouldNotHaveSet.add(key));
      Array.from(keysShouldNotHaveSet).forEach(
        (key) => delete data[key],
      );
      delete data?.exterior;
      delete data?.exteriorDamaged;
      delete data?.reportedPolice;
      delete data?.file_policeReport;
      delete data?.additionalDetails;
      delete data?.belongings?.damagedItemsFire;
      delete data?.belongings?.damagedItemsWindHail;
      delete data?.file_exteriorDamages;
      break;

    case 'windHail':
      fireKeys.forEach((key) => keysShouldNotHaveSet.add(key));
      waterKeys.forEach((key) => keysShouldNotHaveSet.add(key));
      theftOrLostKeys.forEach((key) => keysShouldNotHaveSet.add(key));
      Array.from(keysShouldNotHaveSet).forEach(
        (key) => delete data[key],
      );
      delete data?.reportedPolice;
      delete data?.file_policeReport;
      delete data?.additionalDetails;
      delete data?.belongings?.damagedItemsFire;
      delete data?.belongings?.damagedItemsWater;
      if (!data?.windHailDamage || !data?.windHailDamage?.selectedValues || !data?.windHailDamage?.selectedValues?.includes('waterDamage')) {
        delete data.indoorRoomsDamaged;
        delete data.interior;
        delete data.file_interiorDamages;
      }
      break;

    case 'theftMissing':
      fireKeys.forEach((key) => keysShouldNotHaveSet.add(key));
      windKeys.forEach((key) => keysShouldNotHaveSet.add(key));
      waterKeys.forEach((key) => keysShouldNotHaveSet.add(key));
      Array.from(keysShouldNotHaveSet).forEach(
        (key) => delete data[key],
      );
      delete data?.damageFromStormOrWeather;
      delete data?.exterior;
      delete data?.exteriorDamaged;
      delete data?.file_exteriorDamages;
      delete data?.belongingsDamaged;
      delete data?.belongings?.damagedItemsFire;
      delete data?.belongings?.damagedItemsWindHail;
      delete data?.belongings?.damagedItemsWater;
      delete data?.indoorRoomsDamaged;
      delete data?.interior;
      delete data?.file_interiorDamages;
      // If lost is false, clear lost items
      if (!data?.itemLostOrStolen || data?.itemLostOrStolen?.value === false) {
        delete data?.typeMissingItems;
        delete data?.lastTimeSawItem;

        if (data?.stolenFrom && data?.stolenFrom.value === 'somewhereElse') {
          delete data?.forcedEntryDamage;
        }
      }

      // If lost is true, clear stolen items
      if (!data?.itemLostOrStolen || (data?.itemLostOrStolen?.value && data?.itemLostOrStolen?.value === true)) {
        delete data?.typeStolenItems;
        delete data?.reportedPolice;
        delete data?.whereDamageHome;
        delete data?.forcedEntryDamage;
        delete data?.additionalDetails;
        delete data?.locationOccupied;
        delete data?.anyoneHome;
        delete data?.canResideHome;
        delete data?.contactCleaningDamages;
        delete data?.file_contactInformation;
        delete data?.assistCleaningDamages;
        if (newFormData?.whatHappenedPropertyReview && newFormData?.whatHappenedPropertyReview?.fields && newFormData?.whatHappenedPropertyReview?.fields?.length > 1) {
          newFormData.additionalInfoPropertyReview.fields = newFormData.additionalInfoPropertyReview.fields.filter((item) => item.label !== 'Forced entry');
          // newFormData.additionalInfoPropertyReview2.fields = [];
        }
      }

      if (!data?.forcedEntryDamage || (data?.forcedEntryDamage?.value && (data?.stolenFrom.value !== 'atHome' && data?.stolenFrom?.value !== 'anotherLocationIOwnOrRent'))) {
        delete data?.file_damagedAreas;
      }
      break;

    default:
  }

  if (!data.reportedFire || data.reportedFire.value === false) {
    delete data?.fire;
    delete data?.file_fireReport;
  }
  // if Interior Damages is set false, remove any dependent info filled in previously
  if (!data?.indoorRoomsDamaged
      || (data?.indoorRoomsDamaged?.value === false)) {
    delete data?.interior;
    delete data?.file_interiorDamages;
  }

  // If Damages to belongings is set to false, remove any corrosponding info filled in previously
  if (!data.belongingsDamaged || data?.belongingsDamaged.value === false) {
    delete data?.belongings?.damagedItemsWater;
    delete data?.belongings?.damagedItemsWindHail;
    delete data?.belongings?.damagedItemsFire;
    delete data?.file_belongingsDamages;
  }

  if (!data.reportedPolice || data?.reportedPolice?.value === false) {
    if (newFormData.additionalInfoPropertyReview && newFormData.additionalInfoPropertyReview.fields && newFormData.additionalInfoPropertyReview.fields.length > 1) {
      newFormData.additionalInfoPropertyReview.fields = newFormData.additionalInfoPropertyReview.fields.filter((item) => item.label === 'Police report');
      newFormData.additionalInfoPropertyReview2.fields = [];
    }
    delete data?.file_policeReport;
    delete data?.police;
  }
  if (!data?.exteriorDamaged || data?.exteriorDamaged.value === false) {
    delete data?.exterior;
  }

  if (!data?.exterior || !data?.exterior?.damagedAreas || !data?.exterior?.damagedAreas?.selectedValues?.includes('roof')) {
    delete data?.exterior?.roofSlopes;
  }

  if (!data?.exterior || !data?.exterior?.damagedAreas || !data?.exterior?.damagedAreas?.selectedValues?.includes('fence')) {
    delete data?.exterior?.fenceSections;
    delete data?.exterior?.fenceMaterial;
  }

  if (!data?.exterior || !data?.exterior?.damagedAreas || !data?.exterior?.damagedAreas?.selectedValues?.includes('siding')) {
    delete data?.exterior?.homeSides;
  }

  return data;
}

function sanitizeAuto(newFormData) {
  const { data } = newFormData.auto;

  if (has(data, 'lossCause.value')) {
    if (data?.lossCause?.value === 'multi_vehicle') {
      // delete data?.fire; // show = data.reportedFire && data.reportedFire.value
      delete data?.secLossCause_single_vehicle;
      delete data?.secLossCause_weather_events;
      delete data?.secLossCause_crime;
      delete data?.secLossCause_random;
      delete data?.wasVehicleParked;
      delete data?.waterEnterVehicle;
      delete data?.fireDamage;
      delete data?.animalTypeHit;
      delete data?.ownerContactInformation;
      delete data?.windshieldDamaged;
      delete data?.knowAnyDamages;
      delete data?.otherInformation;
      delete data?.typeOfObjectHit;
      delete data?.arePartsMissing;
      if (!data?.secLossCause_multi_vehicle || data?.secLossCause_multi_vehicle.value !== 'other') {
        delete data?.pleaseTellUsWhatHappened;
      }
      if (!data?.secLossCause_multi_vehicle || data?.secLossCause_multi_vehicle.value === 'iRearEnded' || data?.secLossCause_multi_vehicle.value === 'iChangedLanes'
        || data?.secLossCause_multi_vehicle.value === 'iTurnedLeft' || data?.secLossCause_multi_vehicle.value === 'iBacked' || data?.secLossCause_multi_vehicle.value === 'iStruckParked'
       ) {
        delete data?.wasVehicleHitAndRun;
      }
    } else if (data?.lossCause?.value === 'single_vehicle') {
      delete data?.vehiclesInvolved;
      delete data?.fireDamage;
      delete data?.waterEnterVehicle;
      delete data?.secLossCause_multi_vehicle;
      delete data?.secLossCause_weather_events;
      delete data?.secLossCause_crime;
      delete data?.secLossCause_random;
      delete data?.wasVehicleParked;
      delete data?.windshieldDamaged;
      delete data?.knowAnyDamages;
      delete data?.otherInformation;
      delete data?.pleaseTellUsWhatHappened;
      delete data?.arePartsMissing;
      delete data?.wasVehicleHitAndRun;

      if (!data?.secLossCause_single_vehicle || data?.secLossCause_single_vehicle.value !== 'collisionWithObjectGround') {
        delete data?.typeOfObjectHit;
      }

      if (!data?.secLossCause_single_vehicle || data?.secLossCause_single_vehicle.value !== 'collisionWithAnimal') {
        delete data?.animalTypeHit;
      }
    } else if (data?.lossCause.value === 'weather_events') {
      delete data?.vehiclesInvolved;
      delete data?.secLossCause_multi_vehicle;
      delete data?.secLossCause_single_vehicle;
      delete data?.secLossCause_crime;
      delete data?.secLossCause_random;
      delete data?.animalTypeHit;
      delete data?.ownerContactInformation;
      delete data?.windshieldDamaged;
      delete data?.knowAnyDamages;
      delete data?.otherInformation;
      delete data?.typeOfObjectHit;
      delete data?.pleaseTellUsWhatHappened;
      delete data?.arePartsMissing;
      delete data?.passengers;
      delete data?.wasVehicleHitAndRun;
      if (data?.secLossCause_weather_events && data?.secLossCause_weather_events.value !== 'flooding') {
        delete data?.waterEnterVehicle;
      }

      if (data?.secLossCause_weather_events && data?.secLossCause_weather_events.value !== 'fire') {
        delete data?.fireDamage;
        delete data?.reportedFire;
        delete data?.file_fireReport;
      }
    } else if (data?.lossCause.value === 'crime') {
      delete data?.vehiclesInvolved;
      delete data?.secLossCause_weather_events;
      delete data?.secLossCause_multi_vehicle;
      delete data?.secLossCause_single_vehicle;
      delete data?.secLossCause_random;
      delete data?.waterEnterVehicle;
      delete data?.animalTypeHit;
      delete data?.windshieldDamaged;
      delete data?.ownerContactInformation;
      delete data?.typeOfObjectHit;
      delete data?.pleaseTellUsWhatHappened;
      delete data?.passengers;
      delete data?.wasVehicleHitAndRun;

      if (!(data?.secLossCause_crime && data?.secLossCause_crime.value !== 'theft' && data?.secLossCause_crime.value !== 'attemptedTheft')) {
        delete data?.wasVehicleParked;
        delete data?.vehicleTowed;
      }

      if (data?.secLossCause_crime && data?.secLossCause_crime.value !== 'theft') {
        delete data?.knowAnyDamages;
      } else if (data?.secLossCause_crime && data?.secLossCause_crime.value === 'theft' && (!data.wasVehicleFound || !data.wasVehicleFound.value)) {
        delete data?.knowAnyDamages;
      }

      if (data?.secLossCause_crime && data?.secLossCause_crime.value !== 'arsonFire') {
        delete data?.fireDamage;
        delete data?.reportedFire;
        delete data?.file_fireReport;
      }

      if (data?.secLossCause_crime?.value !== 'attemptedTheft'
        && !((data?.secLossCause_crime?.value === 'vandalism' || data?.secLossCause_crime?.value === 'arsonFire') && data?.wasVehicleParked?.value)) {
        delete data?.otherInformation;
      }

      if (data?.secLossCause_crime && data?.secLossCause_crime.value !== 'attemptedTheft'
          && data?.secLossCause_crime.value !== 'theft') {
        delete data?.arePartsMissing;
      } else if (data?.secLossCause_crime && data?.secLossCause_crime.value === 'theft'
          && data?.wasVehicleFound && data?.vehicleCurrentLocation && (!data?.wasVehicleFound.value || data?.vehicleCurrentLocation.value === 'iDontKnow')) {
        delete data?.arePartsMissing;
      }
    } else if (data?.lossCause.value === 'random') {
      delete data?.vehiclesInvolved;
      delete data?.arePartsMissing;
      delete data?.secLossCause_weather_events;
      delete data?.secLossCause_multi_vehicle;
      delete data?.secLossCause_single_vehicle;
      delete data?.secLossCause_crime;
      delete data?.waterEnterVehicle;
      delete data?.animalTypeHit;
      delete data?.ownerContactInformation;
      delete data?.knowAnyDamages;
      delete data?.otherInformation;
      delete data?.typeOfObjectHit;
      delete data?.pleaseTellUsWhatHappened;
      delete data?.passengers;
      delete data?.wasVehicleHitAndRun;

      if (data?.secLossCause_random && data?.secLossCause_random.value !== 'flyingFallingObjects') {
        delete data?.windshieldDamaged;
      }

      if (data?.secLossCause_random.value !== 'explosion') {
        delete data?.fireDamage;
        delete data?.reportedFire;
        delete data?.file_fireReport;
      }
    }

    if (data?.vehicleCurrentLocation) {
      if (data?.lossCause && data?.lossCause.value === 'crime' && data?.secLossCause_crime) {
        if (data?.secLossCause_crime && data?.secLossCause_crime.value === 'theft'
            && !(data?.wasVehicleFound && data?.wasVehicleFound.value)) {
          delete data?.vehicleCurrentLocation;
        }
        if ((data?.secLossCause_crime.value === 'vandalism' || data?.secLossCause_crime.value === 'arsonFire')
            && !(data?.wasVehicleParked && data?.wasVehicleParked.value)) {
          delete data?.vehicleCurrentLocation;
        }
      }
    }

    if (!data?.animalTypeHit || data?.animalTypeHit?.value !== 'otherDomesticAnimal') {
      delete data?.domesticAnimalDescription;
      delete data.ownerContactInformation;
      delete data.owner;
    }

    if ((data?.vehicleTowed && data?.vehicleTowed.value === false)
        || (data?.lossCause.value === 'crime' && data?.secLossCause_crime.value === 'theft' && data?.wasVehicleFound && data?.wasVehicleFound.value === false)) {
      delete data?.towProvider;
    }

    if (!data?.whoDrivingVehicle
        || (data?.whoDrivingVehicle.value && data?.whoDrivingVehicle?.value?.name !== 'Driver not listed')) {
      delete data?.file_driversLicense;
      delete data?.driver;
    }

    if (!data?.wasVehicleParked || data?.wasVehicleParked?.value !== false) {
      delete data?.accidentDescription;
    }

    if (has(data, 'collectDriversInformation.value')
        && data?.collectDriversInformation?.value === true
        && has(data, 'applyThirdParty.value')) {
      delete data?.applyThirdParty;
    } else if (has(data, 'collectDriversInformation.value')
        && data?.collectDriversInformation?.value === false
        && has(data, 'thirdParty.peopleInTheOtherVehiclesInfo')) {
      delete data?.thirdParty.peopleInTheOtherVehiclesInfo;
    }

    // If police reported is falce, remove any police report documents
    if (!data?.reportedPolice || data?.reportedPolice.value === false) {
      if (data?.file_policeReport?.uploadedDocuments
          && data?.file_policeReport?.uploadedDocuments.length > 0) {
        data?.file_policeReport?.uploadedDocuments.forEach((file) => {
          const index = newFormData.additionalInfoAutoReview4.files.indexOf(file.name);
          if (index !== -1) {
            newFormData.additionalInfoAutoReview4.files.splice(index, 1);
          }
        });
      }
      delete data?.file_policeReport;
      delete data?.police;
    }
  }

  if (!data?.vehicleSafelyDriven || data?.vehicleSafelyDriven?.value === true) {
    delete data.vehicleStartDrive;
  }

  if (!data.vehicleIncident || !data.vehicleIncident?.isThereDamage || (data?.vehicleIncident?.isThereDamage?.value === false)) {
    delete data?.vehicleIncident?.vehicleDamagesPanel;
  }

  if (!data.reportedFire || data.reportedFire.value === false) {
    delete data?.fire;
    delete data?.file_fireReport;
  }

  if (!data.ownerContactInformation || data.ownerContactInformation.value === false) {
    delete data?.owner;
  }
  return data;
}

function sanitizeAbOnlyData(newFormData) {
  const { data } = newFormData.abonly;

  if (data?.lossCause?.value === 'occupantThirdPartyVehicle') {
    delete data?.collectDriversInformation;
    delete data?.thirdParty;
    if (data?.secLossCause?.value !== 'other') {
      delete data.abOnlyDescription;
    }
  } else if (data?.lossCause?.value === 'injuredPedestrianOrCyclist') {
    delete data?.secLossCause;
  }

  if (!data?.driversInformation || data?.driversInformation?.value === false) {
    delete data?.abDriver;
  }

  if (!data?.reportedPolice || data?.reportedPolice?.value === false) {
    delete data?.file_policeReport;
    delete data?.police;
  }

  if (!data.collectDriversInformation || data?.collectDriversInformation?.value === false) {
    delete data?.thirdParty;
  }
  return data;
}

// When user revisits the question and changes the value, formio doesn't handle data cleanup automatically.
// this func cleans up data across the application on click of continue button'
export function validateAndSanitizeData(newFormData) {
  if (newFormData?.claim_type?.claim_type === 'Home' && newFormData?.property?.data?.lossCause?.value) {
    // Property data clean up
    const data = sanitizePropertyData(newFormData);
    newFormData.property.data = data;
  } else if (newFormData?.claim_type?.claim_type === 'Vehicle') {
    if (newFormData.claim_type.vehicle?.policySystemId === 'injuryOnly' && newFormData?.abonly?.data?.lossCause?.value) {
      // Ab only data clean-up
      const data = sanitizeAbOnlyData(newFormData);
      newFormData.abonly.data = data;
    } else if (newFormData?.auto?.data?.lossCause?.value) {
      // Auto data clean-up
      const data = sanitizeAuto(newFormData);
      newFormData.auto.data = data;
    }
  }
}
